import { Config } from '../../config';
import { currentDomainConfig } from '../../domain-config';
import { CountrySlug } from '../../utils/locale';
import { AuthClient } from './AuthClient';

/** Authentication scheme for tokens minted from an Auth API session. */
export const ACCESS_TOKEN_SCHEME = 'Leo-Access-Token';

/** The Accept-Language value per country, matching what the api clients send. */
const acceptLanguages: Record<CountrySlug, string> = {
    sweden: 'sv-SE',
    norway: 'nb-NO',
    denmark: 'da-DK',
    finland: 'fi-FI',
    germany: 'de-DE',
};

/**
 * The application-wide auth client. Constructing it is side effect free — no
 * request is made until AuthService starts the monitor — and it is shared as a
 * module instance so the api transports can ask it for tokens without going
 * through React context.
 */
export const authClient = new AuthClient({
    baseUrl: Config.authApi[currentDomainConfig.countrySlug],
    acceptLanguage: acceptLanguages[currentDomainConfig.countrySlug],
});
